module.exports = __webpack_public_path__ + "img/trucks.ce00b747.png";